import { I18n } from 'aws-amplify';
import { translations } from '@aws-amplify/ui-react';

//Documentación de métodos:
// https://aws-amplify.github.io/amplify-js/api/classes/i18n.html

// Etiquetas traducibles
// https://github.com/aws-amplify/amplify-ui/blob/main/packages/ui/src/i18n/dictionaries/authenticator/es.ts

I18n.putVocabularies(translations);
I18n.setLanguage('es');

//Con esto sobreescribo los valores de la tabla de traducciones
I18n.putVocabularies({    
  es: {
    'Sign in': 'Acceder',
    'Sign In': 'Acceso',
    'Forgot your password?':"¿Olvidaste tu contraseña?",
    'Email': 'Correo electrónico',
    'Create Account': 'Registro',    
    'Name': 'Nombre',
    'Incorrect username or password.': 'Nombre de usuario o contraseña incorrecta',
    'Family Name': 'Apellidos',
    'Phone': 'Número de teléfono',
    'Enter your email': 'Introduce tu dirección de correo electrónico',
    'Send code': 'Enviar código',
    'SignUp is not permitted for this user pool': 'Los registros están temporalmente cerrados por ampliación de la plataforma. Hemos registrado tu solicitud y te avisaremos cuando reabran. Gracias por tu paciencia.',
    'We Emailed You': 'Te hemos enviado un e-mail',
    'Your code is on the way. To log in, enter the code we emailed to': 'Tu código está en camino, si no lo recibes en un minuto revisa en tu email la carpeta de "spam". Para acceder introduce el código que te hemos enviado a ',
    'It may take a minute to arrive.': ' ',
    'Enter your code': 'Introduce tu código',
    'An account with the given email already exists.':'Ya existe una cuenta registrada con ese email.',
    'Password must have at least 8 characters':'• La contraseña debe tener al menos 8 caracteres',
    'Password must have upper case letters':'• La contraseña debe tener letras mayúsculas',
    'Password must have lower case letters':'• La contraseña debe tener letras minúsculas',
    'Password must have numbers':'• La contraseña debe tener números',
    'Password must have special characters':'• La contraseña debe tener caracteres especiales',
    'Your passwords must match':'Tus contraseñas deben coincidir',
    'Submitting':'Reenviando código',
    'Attempt limit exceeded, please try after some time.':'Has excedido el límite de intentos, inténtalo de nuevo en unos minutos.',
    'Password attempts exceeded': 'Número máximo de intentos excedido, inténtalo de nuevo en unos minutos.',
    'Invalid phone number provided/Unable to send the message. User pool does not have SMS configuration to send messages.': 'No ha sido posible enviar el SMS.',
    'Password does not conform to policy: Password must have symbol characters': 'Contraseña inválida: debe tener caracteres especiales.',
    'Password does not conform to policy: Password not long enough':'Contraseña inválida: es demasiado corta.',
    'Password does not conform to policy: Password must have uppercase characters':'Contraseña inválida: debe incluir mayúsculas.',
    'Password does not conform to policy: Password must have lowercase characters':'Contraseña inválida: debe incluir minúsculas.',
    'Password does not conform to policy: Password must have numeric characters':'Contraseña inválida: debe incluir números.',
    'We Sent A Code':'Código de verificación enviado',
    'Your code is on the way. To log in, enter the code we sent you. It may take a minute to arrive.':'Tu código de verificación está en camino. Para poder acceder introduce el código que recibas. Podría tardar hasta un minuto en llegarte.',
    'Invalid verification code provided, please try again.':'Código de verificación inválido, inténtalo de nuevo.',
    'Network error': 'No tienes conexión a internet.',
    "1 validation error detected: Value null at 'attributeName' failed to satisfy constraint: Member must not be null": "Selecciona el medio por el que quieres recibir el código."    
    }  
});